'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Well = require('react-bootstrap/lib/Well');

var _Well2 = _interopRequireDefault(_Well);

var _common = require('../common');

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var renderFileTypeFromUrl = _utils.TableRenderingUtils.renderFileTypeFromUrl,
    renderFilenameFromUrl = _utils.TableRenderingUtils.renderFilenameFromUrl;

var EmailAttachmentsTable = (0, _classAutobindDecorator2.default)(_class = (_temp = _class2 = function (_Component) {
  _inherits(EmailAttachmentsTable, _Component);

  function EmailAttachmentsTable() {
    _classCallCheck(this, EmailAttachmentsTable);

    return _possibleConstructorReturn(this, (EmailAttachmentsTable.__proto__ || Object.getPrototypeOf(EmailAttachmentsTable)).apply(this, arguments));
  }

  _createClass(EmailAttachmentsTable, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Well2.default,
        null,
        _react2.default.createElement(_common.DocumentTable, {
          columns: this.columns,
          documents: (0, _mobx.toJS)(this.props.attachments),
          title: 'Attachments'
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'columns',
    get: function get() {
      return [{
        accessor: 'file',
        Cell: renderFileTypeFromUrl,
        className: 'col-file',
        Header: 'File Type',
        maxWidth: 20
      }, {
        accessor: 'file',
        Cell: renderFilenameFromUrl,
        Header: 'Name',
        minWidth: 200
      }, {
        accessor: 'file',
        Cell: function Cell(row) {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _Button2.default,
              { bsStyle: 'link', href: row.value, target: '_blank' },
              _react2.default.createElement(_common.Icon, { type: 'download' })
            )
          );
        },
        className: 'col-buttons',
        Header: 'actions',
        minWidth: 30
      }];
    }
  }]);

  return EmailAttachmentsTable;
}(_react.Component), _class2.propTypes = {
  attachments: _mobxReact.propTypes.arrayOrObservableArray,
  emailId: _propTypes2.default.string.isRequired
}, _temp)) || _class;

var _default = EmailAttachmentsTable;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(renderFileTypeFromUrl, 'renderFileTypeFromUrl', '/app/src/components/page-case/EmailAttachmentsTable.js');
  reactHotLoader.register(renderFilenameFromUrl, 'renderFilenameFromUrl', '/app/src/components/page-case/EmailAttachmentsTable.js');
  reactHotLoader.register(EmailAttachmentsTable, 'EmailAttachmentsTable', '/app/src/components/page-case/EmailAttachmentsTable.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/EmailAttachmentsTable.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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